module.exports = __webpack_public_path__ + "static/media/banner2.66b9813a.png";